import { eCurrency, eTv10PercentPaymentType, eFrequencyType, eTv10PercentPaymentStatus } from "@hub/generated/enums";
import { PaymentGeneratorPaymentsModel } from "@hub/models/paymentGeneratorPayments.model";

export class PaymentGeneratorModel {
    public PaymentCount: number;
    public TotalPaymentAmount: number;
    public CurrencyTypeId: eCurrency;
    public PaymentTypeId: eTv10PercentPaymentType;
    public FrequencyTypeId: eFrequencyType
    public Description: string;
    public PaymentsData: PaymentGeneratorPaymentsModel[];
    public Commission: number;
    public StartDate: Date;
}